"use client";

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, createContext, use, useCallback, useState } from "react";
import { fetchProductVat } from "@/contexts/products/_actions/fetch-product-vat";
import type { ProductModel } from "@/services/api/shop/models/product.model";
const ProductCountryVatContext = createContext<ContextProps | null>(null);
type ContextProps = {
  readonly countryCode: string | null;
  readonly setCountryCode: (countryCode: string | null) => void;
  readonly isPending: boolean;
  readonly setIsPending: (isPending: boolean) => void;
};
type ProductCountryVatCodeProviderProps = {
  readonly children: ReactNode;
};
export function useProductCountryVat() {
  const $ = _c(8);
  const context = use(ProductCountryVatContext);
  if (!context) {
    throw new Error("useProductCountryVat must be used within a ProductCountryVatCodeProvider");
  }
  const {
    countryCode,
    setIsPending
  } = context;
  let t0;
  if ($[0] !== countryCode || $[1] !== setIsPending) {
    t0 = async product => {
      if (!countryCode) {
        return null;
      }
      setIsPending(true);
      const result = await fetchProductVat(countryCode, product);
      setIsPending(false);
      return result;
    };
    $[0] = countryCode;
    $[1] = setIsPending;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const getPriceWithVat = t0;
  let t1;
  if ($[3] !== context.countryCode || $[4] !== context.isPending || $[5] !== context.setCountryCode || $[6] !== getPriceWithVat) {
    t1 = {
      countryCode: context.countryCode,
      getPriceWithVat,
      isPending: context.isPending,
      setCountryCode: context.setCountryCode
    };
    $[3] = context.countryCode;
    $[4] = context.isPending;
    $[5] = context.setCountryCode;
    $[6] = getPriceWithVat;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}
export function ProductCountryVatProvider(t0) {
  const $ = _c(6);
  const {
    children
  } = t0;
  const [countryCode, setCountryCode] = useState(null);
  const [isPending, setIsPending] = useState(false);
  let t1;
  if ($[0] !== countryCode || $[1] !== isPending) {
    t1 = {
      countryCode,
      isPending,
      setCountryCode,
      setIsPending
    };
    $[0] = countryCode;
    $[1] = isPending;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children || $[4] !== t1) {
    t2 = <ProductCountryVatContext value={t1}>{children}</ProductCountryVatContext>;
    $[3] = children;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}